import classNames from 'classnames'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useCookies } from 'react-cookie'
import ReactResizeDetector from 'react-resize-detector'
import EmptyBlock from '../../components/common/EmptyBlock'
import TailwindWrapper from '../../components/container/TailwindWrapper'
import EventBanner from '../../components/menu/EventBanner'
import LandingMenu from '../../components/menu/LandingMenu'
import PortalMenuV2 from '../../components/menu/PortalMenuV2'
import { useCurrentUser } from '../../modules/context/UserContext'
import { isMulticampus } from '../../modules/utils'
import { COOKIE_OPT } from '../../modules/vars'

interface NewMainMenuProps {
  dashboard?: boolean
  portal?: boolean | string
  landing?: boolean
  noBanner?: boolean
  noShadow?: boolean
  pageName?: string
  pageDescription?: string
  noProfileMenu?: boolean
}

const NewMainMenu = ({
  dashboard,
  portal,
  landing,
  noBanner,
  noShadow,
  pageName,
  pageDescription,
  noProfileMenu,
}: NewMainMenuProps) => {
  const [isMobile, setIsMobile] = useState(false)
  const { currentUser } = useCurrentUser()
  const topRef = useRef(null)
  const [height, setHeight] = useState(70)
  const [segment, setSegment] = useState('')
  const [cookies, setCookie] = useCookies(['is_close_early_promotion_banner'])
  const [showEvent, setShowEvent] = useState(false)

  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])

  const handleBannerClose = (e) => {
    e.preventDefault()
    setCookie('is_close_early_promotion_banner', true, COOKIE_OPT)
    setShowEvent(false)
  }

  useEffect(() => {
    const pageURL = window.location.href
    const lastURLSegment = pageURL.slice(pageURL.lastIndexOf('/') + 1)
    setSegment(lastURLSegment)
  }, [])

  const showSmEventBanner = !isMulticampus(currentUser) && !noBanner && showEvent
  const showLgEventBanner = !isMulticampus(currentUser) && !noBanner && showEvent

  return (
    <TailwindWrapper>
      <ReactResizeDetector handleHeight onResize={(w, h) => setHeight(h)}>
        <Fragment>
          <div
            ref={topRef}
            style={{
              boxShadow: dashboard && '0 1px 3px 0 rgba(51, 52, 54, 0.12)',
            }}
            className={classNames(
              [noShadow ? '' : 'shadow-light-lg shadow-sm', !dashboard || isMobile ? 'bg-white' : 'bg-gray-50'],
              'fixed-top fixed left-0 right-0 z-[111]'
            )}
          >
            <div className="hidden sm:block">
              {showSmEventBanner && (
                <EventBanner portal={portal} handleClose={handleBannerClose} currentUser={currentUser} />
              )}
            </div>
            <div className="block sm:hidden">
              {showLgEventBanner && (
                <EventBanner portal={portal} handleClose={handleBannerClose} currentUser={currentUser} />
              )}
            </div>
            {landing && <LandingMenu currentUser={currentUser} isEventBannerOpen={showSmEventBanner} />}
            {portal &&
              (isMobile ? (
                <LandingMenu currentUser={currentUser} isEventBannerOpen={showSmEventBanner} />
              ) : (
                <PortalMenuV2
                  noBanner={noBanner}
                  noProfileMenu={noProfileMenu}
                  activeId={portal}
                  currentUser={currentUser}
                  pageName={pageName}
                  pageDescription={pageDescription}
                />
              ))}
          </div>
        </Fragment>
      </ReactResizeDetector>
      <EmptyBlock h={height} />
    </TailwindWrapper>
  )
}

export default NewMainMenu
